<ngx-alerts></ngx-alerts>

<div class="form-body">
    <div class="row">
        <div class="img-holder">
            <ng-content select="[loginSidebar]"></ng-content>
        </div>
        <div class="form-holder">
            <div class="form-content">
                <div class="form-items">
                    <div class="page-links">
                        <a class="active">
                            <ng-content select="[loginHeader]"></ng-content>
                        </a>
                    </div>
                    <ng-container *ngIf="inCognitoLogin">
                        <form role="form" name='form' (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm">
                            <label class='label-txt'>Username</label>
                            <input class="form-control" autofocus type="text" name="email" [(ngModel)]="loginUser.email"
                                #email="ngModel" placeholder="Email Address"
                                [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required email
                                autocomplete="email">
                            <div *ngIf="f.submitted && email.invalid" class="invalid-feedback email-valid-check">
                                <div *ngIf="email?.errors?.required">Email add required</div>
                                <div *ngIf="email?.errors?.email">Invalid Email id</div>
                            </div>
                            <label class='label-txt'>Password</label>
                            <input class="form-control" type="password" name="password" [(ngModel)]="loginUser.password"
                                #password="ngModel" placeholder="Password"
                                [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" required minlength="6"
                                autocomplete="current-password">
                            <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                                <div *ngIf="password?.errors?.required">Password Required</div>
                                <div *ngIf="password?.errors?.minlength">Minimum length 6</div>
                            </div>
                            <div class="form-button">
                                <button id="submit" *ngIf="LoginBtnVisible" type="submit" class="ibtn">Sign In</button>
                                <a href="javascript:void(0)" (click)="launchForgotPassword()">Forgot Password</a>

                            </div>
                        </form>
                        <div class="other-links">
                            <span>New user
                                <a href='javascript:void(0)' (click)='initRegistration()'>Create Account</a>
                            </span>
                            <br>
                            <span>&copy;
                                <a href='https://www.bcone.com' rel="noopener noreferrer" target='_blank'>Bristlecone,
                                    Inc.</a> Allright reserved</span>
                        </div>
                    </ng-container>

                    <ng-container>
                        <div class="form-button">
                            <button (click)="ssoLogin()"  *ngIf="enableSso" class="ibtn">Login with SSO</button>
                            <button (click)="azureLogin()"  *ngIf="enableAzure" class="ibtn">Login with Azure AD</button>
                            <button (click)="cognitoLogin()" *ngIf="enableCognito" class="ibtn">Login with Cognito</button>
                            <button (click)="azureB2CLogin()" *ngIf="enableB2C" class="ibtn">Login with B2C</button>            
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
